import { useGlobals } from "@/components/providers/globals-provider.tsx";
import useForceDownloadFile from "@/features/downloads/hooks/use-force-download-file.ts";
import downloadFiles from "@/features/downloads/queries/download-files.ts";
import useMutationApiClient from "@/hooks/use-mutation-api-client.ts";
import { useAppSelector } from "@/redux/store.ts";

export default function useDownloadFiles(onSuccess?: () => void) {
    const { site, locale } = useGlobals();

    const smartNumber = useAppSelector((state) => state.smartNumber.calculatedResult);
    const zipDownloadPath = useAppSelector((state) => state.downloads.zipDownloadPath);

    const { download, isPending: isForceDownloading } = useForceDownloadFile();

    const { isPending: isPreparing, ...data } = useMutationApiClient({
        mutationKey: ["download-file", zipDownloadPath, smartNumber],
        mutationFn: () => downloadFiles(zipDownloadPath, smartNumber, site, locale),
        onSuccess: async (link) => {
            await download(link);
            onSuccess?.();
        },
    });

    return { ...data, isPending: isPreparing || isForceDownloading };
}
